// extracted by mini-css-extract-plugin
export default {"wrap":"ClickFilterableTable_wrap__QYSrc","filter":"ClickFilterableTable_filter__Oz55y","table":"ClickFilterableTable_table__FzPjR"};